import React from "react"
import shuffle from "./Shuffle"
import { useState } from "react"
import "./QuizGame.scss"

function TriviaItem({
  question,
  correctAnswer,
  incorrectAnswers,
  onNextClick,
  onAnswerSelected,
  explanation,
  answerWasCorrect,
}) {
  const allAnswers = [correctAnswer, ...incorrectAnswers]
  const [shuffledAnswers, setShuffledAnswers] = useState(() =>
    shuffle(allAnswers)
  )

  const [selectedAnswer, setSelectedAnswer] = useState(null)
  const hasPickedAnswer = selectedAnswer !== null

  const onAnswerClick = (event) => {
    const playerAnswer = event.target.innerHTML
    setSelectedAnswer(playerAnswer)
    const wasPlayerCorrect = playerAnswer === correctAnswer
    onAnswerSelected(wasPlayerCorrect)
  }

  // console.log(onAnswerSelected)
  let nextButtonClassName = "trivia-item__button trivia-item__next-button "
  if (!hasPickedAnswer) nextButtonClassName += " trivia-item__button--disabled"

  return (
    <div className="quiz-game-questions w-full px-4 sm:px-8 py-8">
      <div className="w-full max-w-2xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg p-6 sm:p-8">
          {/* Question */}
          <h2 className="text-lg sm:text-xl text-center mb-8 min-h-20 flex items-center justify-center font-semibold text-gray-800">
            {question}
          </h2>

          {/* Answers Grid */}
          <ul className="trivia-item__answers grid grid-cols-1 sm:grid-cols-2 p-0 m-0 mb-8">
            {shuffledAnswers.map((answer, i) => {
              let className = "trivia-item__button"
              const isThisCorrect = answer === correctAnswer
              if (hasPickedAnswer) {
                const pickedThisAnswer = answer === selectedAnswer
                if (pickedThisAnswer && isThisCorrect) {
                  className += " trivia-item__button--correct"
                } else if (pickedThisAnswer && !isThisCorrect) {
                  className += " trivia-item__button--incorrect"
                } else {
                  className += " trivia-item__button--disabled"
                }
              }
              return (
                <li className="w-full" key={answer}>
                  <button
                    className={className}
                    onClick={onAnswerClick}
                    disabled={hasPickedAnswer}
                  >
                    {answer}
                  </button>
                </li>
              )
            })}
          </ul>

          {/* Explanation - Only shown after answer is selected */}
          {explanation && hasPickedAnswer && (
            <div className="mb-8 explanation">
              <p>{explanation}</p>
            </div>
          )}

          {/* Next Button */}
          <div className="flex justify-center">
            <button
              className={`${nextButtonClassName} sm:w-40`}
              onClick={onNextClick}
              disabled={!hasPickedAnswer}
            >
              Próxima
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TriviaItem
